// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3gymr","loaderOuter":"PageOverlayLoader_loaderOuter__34Ose"};